import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  id: string;
};

export async function deleteDeliveryApi({ id }: Data) {
  return makeRequest(Service.deleteDelivery(id, await identify()));
}
